import { useState } from 'react';
import { toast } from 'react-toastify';
import {
  Box,
  Button,
  TextField
} from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import { useApi } from '@bumble/app/hooks/use-api';
import { apiError } from '@bumble/app/utils/api-error';

interface RouterIPMonitorTargetEditProps {
  onSubmit: () => void;
  cpeId: string;
  ipMonitorTarget: string;
}
export const RouterIPMonitorTargetEdit = ({ onSubmit, cpeId, ipMonitorTarget }: RouterIPMonitorTargetEditProps) => {
  const api = useApi();
  const [newIPMonitorTarget, setNewIPMonitorTarget] = useState<string>(ipMonitorTarget);

  const cpeInfoUpdatePost = useMutation(api.updateCpeIpMonitorTargetApiV1UpdateCpeIpMonitorTargetPost, {
    onSuccess() {
      toast.success('Updated IP Monitor Target successfully.');
      onSubmit();
    },
    onError: apiError,
  });

  const handleSubmit = () => {
    cpeInfoUpdatePost.mutate({
      cpe_id: cpeId,
      ip_monitor_target: newIPMonitorTarget
    });
  };

  return (
    <Box pt={2}>
      <TextField
        sx={{ mb: 4 }}
        fullWidth
        label="IP Monitor Target"
        variant="outlined"
        value={newIPMonitorTarget}
        onChange={(e) => setNewIPMonitorTarget(e.target.value)}
        autoFocus
      />
      <Box display="flex" justifyContent="flex-end" sx={{ mt: 5 }}>
        <Button variant="outlined" onClick={handleSubmit}>
          Save
        </Button>
      </Box>
    </Box>
  );
};
